'use client';

import { useEffect } from 'react';
import '../styles/index.css';
import { getFriendlyErrorMessage } from '@/utils/errorMessages';

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        console.error('Global Error:', error);
    }, [error]);

    const { title, message } = getFriendlyErrorMessage(error);

    return (
        <html lang="en">
            <body className="flex flex-col min-h-screen items-center justify-center bg-gray-50 font-sans">
                <div className="p-4 w-full max-w-md">
                    <div className="bg-white p-8 rounded-xl shadow-xl text-center border border-gray-200">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">{title}</h2>
                        <p className="text-gray-600 mb-8">
                            {message}
                        </p>

                        <button
                            onClick={() => reset()}
                            className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors w-full"
                        >
                            Reload Application
                        </button>
                    </div>
                </div>
            </body>
        </html>
    );
}
